module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactTransformTenchmark","commonjs2":"ReactTransformTenchmark","commonjs":"ReactTransformTenchmark","amd":"ReactTransformTenchmark"}
// module id = 5
// module chunks = 1